<template>
  <ul class="mb-4 -ml-2 flex md:order-1 md:mb-0" v-if="clinicData">
    <template v-for="(social, index) in socialLinks">
      <li :key="index" v-if="clinicData[social.key]">
        <a
          class="text-muted inline-flex items-center rounded-lg p-2.5 text-sm hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-700"
          :href="formatUrl(clinicData[social.key])"
          :aria-label="social.key"
          target="_blank"
        >
          <img
            :src="require(`@/assets/svg-icons/${social.img}.svg`)"
            :alt="social.key"
            class="object-contain w-full w-8 h-8"
          />
        </a>
      </li>
    </template>
  </ul>
</template>
<script>
export default {
  name: "SocialComponent",
  data() {
    return {
      socialLinks: [
        {
          img: "twitter",
          key: "twitterLink",
        },
        {
          img: "facebook",
          key: "facebookLink",
        },
        {
          img: "instagram",
          key: "instagramLink",
        },
        {
          img: "tiktok",
          key: "tiktokLink",
        },
        {
          img: "whatsapp",
          key: "whatsappLink",
        },
        {
          img: "youtube",
          key: "youTubeLink",
        },
        {
          img: "snapchat",
          key: "snapchatLink",
        },

        // "telegram",
        // "linkedin",
      ],
    };
  },
  computed: {
    clinicData() {
      return this.$store.getters.getClinicData;
    },
  },
  methods: {
    formatUrl(url) {
      return url.startsWith("http") ? url : `https://${url}`;
    },
  },
};
</script>
